module.exports = __webpack_public_path__ + "img/in-person-low.e94765ea.jpg";